import React from 'react'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'

import background from '../../images/auth_background.png'
import logoInternational from '../../images/logo_EN.png'
import logoRuServer from '../../images/logo_RU.png'
import gpBadge from '../../images/google_play_badge.png'
import asBadge from '../../images/app_store_badge.png'
import {getIsRuServer} from "../../helpers/getIsRuServer";

const BackgroundWrapper = styled.div`
  background-color: #fff;
`

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  height: 100vh;
`

const StyledForm = styled.div`
  min-width: 50%;
  margin: 0 0 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex: 1 0 100%;
  }
`

const StyledBackground = styled.div`
  min-width: 50%;
  display: flex;
  background: url(${background}) no-repeat center center;
  background-size: cover;

  @media (max-width: 768px) {
    display: none;
  }
`

const StyledLogo = styled.div`
  position: absolute;
  top: 48px;
  left: 78px;
  width: ${getIsRuServer() ? 88 : 157}px;
  height: 34px;
  background: url(${getIsRuServer() ? logoRuServer : logoInternational}) no-repeat center center;
  background-size: 100% 100%;
`

const StyledFormContainer = styled.div`
  position: relative;
  width: 289px;
`

const StyledLinksAbsoluteWrapper = styled.div`
  position: absolute;
  bottom: 50px;
  left: 0;

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const StyledBadgeWrapper = styled.div`
  display: none;

  @media (min-width: 769px) {
    width: 289px;

    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`

const StyledBadge = styled.div`
  width: 130px;
  height: 40px;

  background: url(${(props) => props.image}) no-repeat no-repeat;
  background-size: contain;

  &:first-child {
    background-position: top left;
  }

  &:last-child {
    background-position: top right;
  }
`

const StyledLinksRow = styled.div`
  margin-top: 20px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledLinkWrapper = styled.div`
  flex: 1;
  display: flex;

  &:first-child {
    justify-content: flex-end;
  }
`

const StyledLink = styled.a`
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  color: #4c84ff;
  text-decoration: none;
  background-color: transparent;

  display: block;
`

const StyledLinkDivider = styled.div`
  width: 1px;
  height: 15px;
  background-color: #4c84ff;
  margin: 0 10px;
`

const AuthPageWrapper = ({ children }) => {
  const isRuServer = getIsRuServer()
  const documentButtonName =
    isRuServer ? 'Документы' : 'Documentation'
  const documentButtonLink =
    isRuServer
      ? 'https://hrs.ru/ru/documentation/'
      : 'http://support.hrsinternational.com/crm/support.php'

  return (
    <BackgroundWrapper>
      <Container>
        <StyledForm>
          <StyledLogo />
          <StyledFormContainer>{children}</StyledFormContainer>
          <StyledLinksAbsoluteWrapper>
            <StyledBadgeWrapper>
              <a
                href="https://play.google.com/store/apps/details?id=com.hrsinternational.servicedeskmobile"
                target="_blank"
              >
                <StyledBadge image={gpBadge} />
              </a>
              <a
                href="https://itunes.apple.com/us/app/hrs-service-desk/id1417133590"
                target="_blank"
              >
                <StyledBadge image={asBadge} />
              </a>
            </StyledBadgeWrapper>
            <StyledLinksRow>
              <StyledLinkWrapper>
                <StyledLink target="_blank" href={'https://hrsintl1.webex.com/mw3300/mywebex/default.do?siteurl=hrsintl1&service=9'}>
                  Webex
                </StyledLink>
              </StyledLinkWrapper>
              <StyledLinkDivider />
              <StyledLinkWrapper>
                <StyledLink href={documentButtonLink}>
                  {documentButtonName}
                </StyledLink>
              </StyledLinkWrapper>
            </StyledLinksRow>
          </StyledLinksAbsoluteWrapper>
        </StyledForm>
        <StyledBackground />
      </Container>
    </BackgroundWrapper>
  )
}

export default withNamespaces()(AuthPageWrapper)
